<div class="modal-content-wrapper">
    <header class="modal-header">
        <h1 class="modal-title">Share your referral link</h1>
    </header>
    <section class="modal-body">
        <div class="addthis_inline_share_toolbox" data-media="assets/images/logo.png" data-title="Register on BlancLiving with my link" [attr.data-url]="link"></div>
    </section>
</div>
